import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// LABOUR CTC VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verify New Labour CTC Inbox (GET)
export const getVerifyNewLabourCTC = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            RoleId: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyNewLabourCTC?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get New Labour CTC by Reference Number (GET)
export const getNewLabourCTCbyRefno = async (params) => {
    try {
        const { transactionRefno } = params;
         // DEBUG
        
        // Validate required parameters
        if (!transactionRefno) {
            throw new Error('TransactionRefno is required');
        }
        
        const queryParams = new URLSearchParams({
            TransactionRefno: transactionRefno.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetNewLabourCTCbyRefno?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve New Labour CTC (PUT)
export const approveNewLabourCTC = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.LabourId) {
            throw new Error('LabourId is required');
        }
        if (!params.TransactionRefno) {
            throw new Error('TransactionRefno is required');
        }
        if (!params.Roleid) {
            throw new Error('Roleid is required');
        }
        if (!params.CreatedBy) {
            throw new Error('CreatedBy is required');
        }
        if (!params.Action) {
            throw new Error('Action is required');
        }
        
        const payload = {
            LabourId: params.LabourId.toString().trim(),
            Month: params.Month ? parseInt(params.Month) : 0,
            Year: params.Year ? parseInt(params.Year) : 0,
            TransactionRefno: params.TransactionRefno.toString().trim(),
            HeadsJsonString: params.HeadsJsonString?.toString().trim() || '',
            Roleid: parseInt(params.Roleid),
            CreatedBy: params.CreatedBy.toString().trim(),
            Action: params.Action.toString().trim(),
            Note: params.Note?.toString().trim() || ''
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveNewLabourCTC`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};